const buildInventoryUrl = ({
	offer,
	sitemap,
	selectedAccountId,
	isGroupSite
}) => {
	const isCPO = offer.applicableConditionString === 'CPO';
	const sitemapKey = isCPO
		? 'INVENTORY_LISTING_DEFAULT_AUTO_USED'
		: 'INVENTORY_LISTING_DEFAULT_AUTO_NEW';
	const fallback = isCPO
		? '/used-inventory/index.htm'
		: '/new-inventory/index.htm';
	const baseUrl = sitemap.get(sitemapKey) || fallback;

	const params = new URLSearchParams();
	params.set('incentiveId', offer.incentiveId);
	const incentiveAccountId = offer.accountId || selectedAccountId;
	if (incentiveAccountId) {
		params.set('incentiveAccountId', incentiveAccountId);
	}
	if (isCPO) {
		params.set('compositeType', 'certified');
	}
	if (!isGroupSite && selectedAccountId) {
		params.set('accountId', selectedAccountId);
	}
	return `${baseUrl}?${params.toString()}`;
};

export default buildInventoryUrl;
